import { buildCrudRoutes } from 'Arch/components/crud/CrudRouter';

const featureBreadcrumb = [
  {
    text: 'Dashboard',
    disabled: false,
    to: 'dashboard',
  },
  {
    text: 'CardMais',
    disabled: false,
    to: 'contacard.submodules.list',
  },
  {
    text: 'Banners',
    disabled: false,
    to: 'contacard.banners.list',
  },
];

export default [
  ...buildCrudRoutes({
    basePath: 'banners',
    baseName: 'contacard.banners',
    moduleActive: 'contacard',
    baseBreadcrumbs: featureBreadcrumb,
    subModuleActive: 'banner',
    card: {
      title: 'Gerenciar Banner',
      icon: 'home',
    },
    listRoute: {
      btnText: 'Adicionar banner',
      navigateBackRoute: 'contacard.submodules.list',
      newRouteName: 'contacard.banners.new',
      pageContent: () => import('@/app/modules/contacard/banners/banner/BannersCrudList.vue'),
      pageTitle: 'Banners',
      filterComponent: () => import('Modules/contacard/banners/banner/components/BannerFilter.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar Banner', searchAttribute: 'search' },
    },
    newRoute: {
      component: () => import('@/app/modules/contacard/banners/banner/BannersForm.vue'),
      breadcrumbs: [
        {
          text: 'Adicionar banner',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('@/app/modules/contacard/banners/banner/BannersForm.vue'),
      breadcrumbs: [
        {
          text: 'Editar Banner',
          disabled: true,
        },
      ],
    },
  }),
];
